import { render } from "./ZipSchoolForm.vue?vue&type=template&id=034126ee&scoped=true"
import script from "./ZipSchoolForm.vue?vue&type=script&lang=js"
export * from "./ZipSchoolForm.vue?vue&type=script&lang=js"

import "./ZipSchoolForm.vue?vue&type=style&index=0&id=034126ee&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034126ee"]])

export default __exports__